<!-- Desktop Sidebar -->
<p-sidebar
  [visible]="true"
  [position]="isRtl ? 'right' : 'left'"
  [modal]="false"
  [dismissible]="false"
  [showCloseIcon]="false"
  [style]="{ width: sidebarCollapsed ? '80px' : '260px' }"
  class="custom-sidebar fixed-sidebar"
  [ngClass]="{ collapsed: sidebarCollapsed, rtl: isRtl }"
>
  <!-- Header -->
  <div class="sidebar-header" [ngClass]="!sidebarCollapsed ?'': 'justify-content-center'">
    <h2 class="logo" *ngIf="!sidebarCollapsed">Tal</h2>
    <button
      class="collapse-btn"
      (click)="collapseSide()"
      aria-label="Collapse sidebar"
      type="button"
    >
      <i
        class="bi"
        [ngClass]="{
          'bi-chevron-double-right':
            (!isRtl && sidebarCollapsed) || (isRtl && !sidebarCollapsed),
          'bi-chevron-double-left':
            (!isRtl && !sidebarCollapsed) || (isRtl && sidebarCollapsed)
        }"
      >
      </i>
    </button>
  </div>

  <!-- Menu -->
  <ul class="menu">
    <ng-container *ngFor="let item of menuItems">
      <li>
        <!-- عنصر بدون children -->
        <a
          *ngIf="!item.children?.length"
          [routerLink]="[item.route]"
          [class.active]="isMenuItemActive(item.route)"
        >
          <i [class]="item.icon || 'bi bi-folder'"></i>
          <span *ngIf="!sidebarCollapsed">{{ item.title }}</span>
        </a>

        <!-- عنصر مع children -->
        <div *ngIf="item.children?.length">
          <span class="menu-parent" (click)="toggleExpand(item)">
            <i [class]="item.icon || 'bi bi-folder'"></i>
            <span *ngIf="!sidebarCollapsed">{{ item.title }}</span>
            <i
              class="bi chevron"
              *ngIf="!sidebarCollapsed"
              [ngClass]="{
                'bi-chevron-down': item.expanded,
                'bi-chevron-right': !item.expanded && !isRtl,
                'bi-chevron-left': !item.expanded && isRtl
              }"
            >
            </i>
          </span>
          <ul class="submenu" *ngIf="item.expanded && !sidebarCollapsed">
            <li *ngFor="let child of item.children">
              <a
                [routerLink]="[child.route]"
                [class.active]="isMenuItemActive(child.route)"
              >
                <i [class]="child.icon || 'bi bi-file-text'"></i>
                <span>{{ child.title }}</span>
              </a>
            </li>
          </ul>
        </div>
      </li>
    </ng-container>
      <a routerLink="Borrower/account-setting">{{ 'Settingpage' | translate }}</a>
  </ul>

  
  <!-- Version -->
</p-sidebar>
